import { ChevronDownIcon, LanguageCodeEnum, Tooltip } from '@systemeio/ui'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

function LanguageSwitcher() {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search)
    const debug = searchParams.get('s.io_debug')
    if (debug) {
      setVisible(true)
    }
  }, [])

  const { i18n } = useTranslation()
  const selectedLanguage = i18n.language
  const changeLanguage = (lng: LanguageCodeEnum) => {
    i18n.changeLanguage(lng)
  }

  if (!visible) {
    return null
  }

  return (
    <Tooltip
      stayOnHover={true}
      className={'h-full'}
      popoverClassName={'p-0 shadow-lg rounded-lg'}
      label={
        <div
          className={twMerge(
            'customScroll bg-background-secondary z-50 max-h-[400px] overflow-hidden overflow-y-auto rounded-lg shadow-lg',
          )}
        >
          <ul className={'text-text-tertiary flex flex-col whitespace-nowrap py-4 text-sm'}>
            {Object.values(LanguageCodeEnum).map(language => (
              <li key={language}>
                <button
                  onClick={() => changeLanguage(language)}
                  disabled={language === selectedLanguage}
                  className={twMerge(
                    'hover:text-brand-primary focus-visible:text-brand-primary main-transition-colors text-start w-full px-7 py-1 focus:outline-hidden',
                    language === selectedLanguage ? 'text-brand-primary' : 'text-text-tertiary',
                  )}
                  data-test={`language-switcher-option-button-${language}`}
                >
                  <p>{language}</p>
                </button>
              </li>
            ))}
          </ul>
        </div>
      }
    >
      <button
        className={twMerge('flex items-center gap-2 text-sm font-normal')}
        data-test="language-switcher-button"
      >
        <div className={twMerge('text-start flex-1 capitalize')}>{selectedLanguage}</div>
        <ChevronDownIcon />
      </button>
    </Tooltip>
  )
}

export default LanguageSwitcher
